import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.url.startsWith('/assets')
      || req.url.includes('assets/')
      || req.url.endsWith('index.html')
      || req.url.startsWith('http://localhost:4200/@ng/')
      || req.url.startsWith('/@ng/')) {
      return next.handle(req);
    }
    let reqHeaders: HttpHeaders = req.headers;
    if (!reqHeaders.has('Content-Type')) {
      reqHeaders.append('Content-Type', 'application/json');
    }

    const cloned = req.clone({
      withCredentials: true,
      headers: reqHeaders
    });
    return next.handle(cloned);
  }
}
